<template>
  <config-base ref="baseRef" :on="$listeners" v-bind="$props" :capacity-unit="capacityUnitI18nKey">
    <template #config>
      <capacity-config-list :config-plan-type="planType" :config-capacity-key="capacityKey" :capacity-unit-i18n-key="capacityUnitI18nKey"></capacity-config-list>
    </template>
    <template #footer v-if="canRmv">
      <zm-button type="link" ghost @click="removePlanByKey" :aria-label="'remove ' + trackingPlanKey + ' plan'">{{ $t('billing.common.remove') }}</zm-button>
    </template>
  </config-base>
</template>

<script>
import planCommon from '@/plans/LARGE_MEETING/mixin';
import {getPlanTotalLicense} from "@/common/service/validate";
import plansMixin from "@/plans/mx/plan";
import ConfigList from "@/components/capacity/config-list.vue";
import ConfigBase from "@/plans/LARGE_MEETING/config/base.vue";
import { computedCapacityLargePlans } from "@/common/service/computers/plans/large-meeting";
import { isBizPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import { planTypes } from '@/common/constants';

const CapacityConfigList = {
  name: 'CapacityConfigList',
  extends: ConfigList,
  mixins: [planCommon],
  computed: {
    mx_licenseTips() {
      return this.totalLimitDesc;
    },
    addAnotherCapacityCta() {
      return this.$t('billing.addAnother.large');
    },
  },
  methods: {
    mx_getMaxHosts() {
      if (isBizPlusContext || this.$context.is.biz2pro) {
        return getPlanTotalLicense(this.getSelectedPlans.filter(item => [planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE].includes(item.type))) || 999;
      }
      return getPlanTotalLicense(this.getCurrentBasePlanInfo?.plans) || 999;
    },
    mx_getIncreaseTips(capacity, license) {
      const currentCapacityPlanCount = getPlanTotalLicense(computedCapacityLargePlans(this.selectedPlanList || [], capacity)) || license;
      return currentCapacityPlanCount >= this.mx_getMaxHosts() ? this.totalLimitDesc : '';
    },
  }
}
export default {
  mixins: [plansMixin, planCommon],
  components: { ConfigBase, CapacityConfigList },
  computed: {
    canRmv() {
      return this.isShowRemoveBtn
    }
  },
  methods: {
    getFirstFocusableControl() {
      return new Promise(resolve => {
        this.$nextTick(() => {
          resolve(this.$el.querySelector('.zm-select-span__inner'))
        })
      })
    }
  },
};
</script>

<style lang="scss">
</style>
